/*
Component to display the uploaded date of the document 
*/
import React from "react";
import Tippy from "@tippyjs/react";
import { DocumentType } from "../../../types/DocumentType";
import { DateDisplay } from "../../../components";
import { ClientDocumentsTableRowColumn } from "./ClientDocumentsTableRowColumn";

export const ClientDocumentsTableRowDateColumn = ({
    data,
    width
} : Readonly<{
    data: DocumentType,
    width: any
}>) => (
    <ClientDocumentsTableRowColumn className="text-end" width={width}>
         <Tippy placement="left" content={(
            <p className="m-0">
                {data.uploadedByName && (<span>Document was uploaded by {data.uploadedByName}.</span>)}
                {!data.uploadedByName && (<span>Document was uploaded by the system.</span>)}
            </p>
        )}>
            <div className="font-monospace">
                <DateDisplay format="DD/MM/YYYY HH:mm">{data.dateUploaded}</DateDisplay>
            </div>
        </Tippy>
    </ClientDocumentsTableRowColumn>
);